import { getReferenceLayer } from './basicCreators';

export function updateCurrentReferenceLayer(referenceLayerId) {
  return function(dispatch, getState) {
    if (referenceLayerId) {
      // Get the industry details
      return dispatch(
        getReferenceLayer(referenceLayerId)
      ).then(referenceLayer =>
        dispatch({ type: 'UPDATE_CURRENT_REFERENCE_LAYER', referenceLayer })
      );
    } else {
      return dispatch(clearCurrentReferenceLayer());
    }
  };
}

export function clearCurrentReferenceLayer() {
  return { type: 'CLEAR_CURRENT_REFERENCE_LAYER' };
}



// WEBPACK FOOTER //
// ./src/actions/referenceLayers/currentReferenceLayersCreators.js